module.exports = "<p>\n   new-game works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/web/game/new-game/new-game.component.html
// module id = ./src/app/web/game/new-game/new-game.component.html
// module chunks = main